import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { ProductVisual } from '../products/ProductVisual';
import { products } from '../../data/products';
interface CloseScreenProps {
  onRestart: () => void;
}
export function CloseScreen({
  onRestart
}: CloseScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-113" data-mp="1skb2uklkvhlc">
      <Reveal data-id="element-114" data-mp="1siqcz8a7kmtt">
        <h2 className="font-heading text-[36px] leading-[1] tracking-[-0.02em] text-white" data-id="element-115" data-mp="1nm9jrzo5ji9v">
          That’s why they’re a family.
        </h2>
      </Reveal>

      <Reveal delay={0.16} className="mt-6" data-id="element-116" data-mp="22a2zdkd8mksg">
        <div className="space-y-1.5" data-id="element-117" data-mp="1xb9ntxhih3ux">
          {['Different personalities.', 'Different strengths.', 'Same Filtek heritage.'].map((line, i) => <motion.p key={line} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.24 + i * 0.14,
          duration: 0.5
        }} className="font-body text-[17px] leading-snug text-white/70" data-id="element-118" data-mp="2b9hnwe9uglab" data-mpi={i}>
                {line}
              </motion.p>)}
        </div>
      </Reveal>

      <Reveal delay={0.7} className="mt-7" data-id="element-119" data-mp="1l6irxmob5ppo">
        <div className="rounded-[26px] bg-primary px-5 py-5" data-id="element-120" data-mp="1q4ak8hsv7due">
          <p className="font-heading text-[26px] leading-[1.05] tracking-[-0.02em] text-background" data-id="element-121" data-mp="1u4um1yodv5mv">
            Change the solution.
            <br data-id="element-122" data-mp="1z2w20aqiiou4" />
            Not the system.
          </p>
          <div className="mt-4 flex items-end justify-between border-t border-[rgba(1,51,43,0.18)] pt-3" data-id="element-123" data-mp="23unskl9o4uk9">
            {products.map(p => <ProductVisual key={p.id} product={p.id} className="h-[84px] w-auto" data-id="element-124" data-mp="28sfkhfabcgog" />)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.9} className="mt-7" data-id="element-125" data-mp="2dr0kpepkf0cw">
        <PillButton tone="dark" full onClick={onRestart} data-id="element-126" data-mp="2htnfnohj91eb">
          Meet the whole family <ArrowRight size={17} weight="bold" aria-hidden="true" data-id="element-127" data-mp="ip5kpenskhum" />
        </PillButton>
        <button type="button" onClick={onRestart} className="mt-4 w-full font-body text-[12px] uppercase tracking-[0.18em] text-white/40 transition-colors hover:text-white/70 focus:outline-none focus-visible:text-white" data-id="element-128" data-mp="dqkgz59bzg1f">
          Start over
        </button>
      </Reveal>
    </div>;
}